import { createSlice } from "@reduxjs/toolkit";
import { getProfileAPI } from "../../api/profile";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getProfileSlice = createSlice({
  name: "getProfile",
  initialState: data,
  reducers: {
   getProfileSlice(state) {
      state.isLoading = true;
    },
   getProfileSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getProfileSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getProfileSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getProfileHandler = () => async (dispatch: any) => {
  try {
    dispatch(getProfileAction.getProfileSlice());
    const response: any = await getProfileAPI();
    
    dispatch(getProfileAction.getProfileSliceSuccess(response));
  } catch (e: any) {
    dispatch(getProfileAction.getProfileSliceFailure(e?.response?.data));
  }
};
export default getProfileSlice.reducer;
export const getProfileAction = getProfileSlice.actions;
